import { Controller } from "@hotwired/stimulus"
import { Tab } from "bootstrap";

export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search)
    const aba = params.get('_aba')
    const el = document.querySelector(`button[data-bs-target="#${aba}"]`)
    if (el) {
      const tab = new Tab(el)
      tab.show()
    }
    window.history.replaceState(null, null, window.location.pathname);
  }
}
